import { css } from 'styled-components';

export interface AlignmentStylesProps {
  alignment?: 'right' | 'left' | 'center';
}

export const alignmentStyles = css<AlignmentStylesProps>`
  text-align: ${({ alignment = 'left' }) => alignment};
`;
